//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TrainingModelCard from "../components/cards/TrainingModelCard";
import Lane from "../components/Lane";
import PublishedModelCard from "../components/cards/PublishedModelCard";
import FacetedSearch from "../components/search/FacetedSearch";
import {insightService} from "../insight-service";
import {mapGetters, mapMutations} from 'vuex';

export default {
  name: "Dashboard",
  components: {
    FacetedSearch,
    TrainingModelCard,
    PublishedModelCard,
    Lane
  },

  props: {
    show: {
      type: Boolean,
      value: true
    },
  },

  data: () => ({
    selectedTab: 'tab-favorites',
    hideSearch: true,
    headers: {
      'fetch.document': 'versionLabel',
      'depth': 'children',
      'properties': '*'
    },
  }),

  computed: {
    ...mapGetters([
      'snackSuccess', 'snackError', 'allModels', 'publishedModels',
      'favoriteModels', 'trainingModels', 'lowModels', 'modelsPP',
      'loading', 'enrichers'
    ])
  },

  mounted() {
    this.setModelsPP(this.$refs.models_pp);
    this.fetchModels();
  },

  methods: {
    navigateToWizard() {
      this.$router.push({name: 'wizard'});
    },
    fetchModels() {
      return insightService.fetchModels(this.modelsPP, this.setModels, this.displayError, this.displayLoading);
    },
    hideSearchNoAnimation() {
      this.$refs.search.style.display = "None";
      this.hideSearch = true;
      this.fetchModels();
    },
    isTrainingCard(model) {
      return insightService.isTraining(model);
    },
    isTrained(model) {
      return insightService.isTrained(model);
    },
    isPublishedCard(model) {
      return insightService.isPublished(model);
    },
    isLowPerformance(model) {
      return insightService.isLowPerformance(model);
    },
    isFavorite(model) {
      return insightService.isFavorites(model);
    },
    toggleModelTab(tab) {
      this.selectedTab = tab;
    },
    ...mapMutations({
      displaySuccess: 'displaySuccess',
      displayError: 'displayError',
      setModels: 'setModels',
      setModelsPP: 'setModelsPP',
      displayLoading: 'displayLoading',
    })
  }
}
